import axios from 'axios'
import { Message, Loading } from 'element-ui'
import { set } from 'shelljs'
import api from './api'
import common from '../assets/js/common'
import alertJs from '@/components/alert/alert.js'

let reqCount = 0
let loading

const service = axios.create({
	baseURL: process.env.SERVER_API+'api/',
	timeout: 20000, // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
	request => {
		reqCount ++
		// loading = Loading.service({
		// 	fullScreen: true, // 全屏loading
		// 	background: 'transparent', // 背景色
		// })
		if(window.localStorage.getItem('usertoken')){ // 请求头添加 token
			// request.headers.token = store.user.token
			request.headers.token = window.localStorage.getItem('usertoken')
		}

		return request
	},
	error => {
		// loading.close()
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		reqCount--
		
		let params = {}
		if(response.config.url==api.upload[1]){ // 上传
		}else if(response.config.method=='get'){
			params = response.config.params
		}else if(response.config.method=='post'){
			params = JSON.parse(response.config.data)
		}
		
		// if(reqCount === 0) loading.close()
		if(response.data.code == 0){
			if(params&&params.page&&params.limit){ // 存在分页, 自动计算总页数
				if(response.data.data.count){
					response.data.data.countpage = Math.ceil(response.data.data.count/params.limit)
				}
			}
			return response.data.data
		}else if(response.data.code == 401){ // 缺少token/token失效
			if(params.try!=true){
				alertJs.alertModal({
					// title: response.data.msg,
					title: '您还未登录，请先登录',
				}).then(()=>{
					window.localStorage.removeItem('usertoken')
					common.toPage('login')
				})
				return Promise.reject('请先登录')
			}
		}else if(response.data.code == 1){
			if(params.try!=true&&params.noFailAlert!=true){
				alertJs.alertModal({
					title: response.data.msg,
				}).then(()=>{})
			}
			return Promise.reject(response.data.msg)
		}
	},
	error => {
		// loading.close()
		reqCount--
		
		let params = {}
		if(error.config.url==api.upload[1]){ // 上传
		}else if(error.config.method=='get'){
			params = error.config.params
		}else if(error.config.method=='post'){
			params = JSON.parse(error.config.data)
		}
		
		if(error.response.data.code == 401){ // 缺少token/token失效
			if(params.try!=true){
				if(error.response.request.responseURL.indexOf('try=true')<0){
					alertJs.alertModal({
						// title: response.data.msg,
						title: '您还未登录，请先登录',
					}).then(()=>{
						window.localStorage.removeItem('usertoken')
						common.toPage('login')
					})
					return Promise.reject('请先登录')
				}
			}
		}else if(error.response.data.code == 1){
			if(params.try!=true&&params.noFailAlert!=true){
				alertJs.alertModal({
					title: error.response.data.msg,
				}).then(()=>{})
				return Promise.reject(error.response.data.msg)
			}
		}
		
		return Promise.reject(error)
	}
)

const request = {}

for(var i in api){
	let apiUrl = api[i];
	request[i] = (params)=>{
		if(i!='upload'){
			params = params||{}
			if(apiUrl[0].toUpperCase()=='POST'){
				return service.post(apiUrl[1],params)
			}else{
				return service({
					method: apiUrl[0].toUpperCase(),
					url: apiUrl[1],
					params,
				})
			}
		}
	}
}

request.upload = (params)=>{ // 必须要放这里，因为api中已经有upload接口
	params = params||{}
	// return service({
	// 	method: api.upload[0].toUpperCase(),
	// 	url: api.upload[1],
	// 	params,
	// })
	
	let formData = new FormData()
	formData.append('file',params.file)
	return service.post(api.upload[1],formData,{
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})
}

// export default service
export default request


// WEBPACK FOOTER //
// ./src/api/request.js